import { GridApi, GridOptions } from '@ag-grid-community/core';
import { Grid, Typography, TextField } from '@atgfr8/atg-ui-tailwind';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
} from '@atgfr8/icons';
import { SelectInput } from '@components';
import { Component } from 'solid-js';

type PaginationProps = {
  gridApi?: GridApi;
  gridOptions: GridOptions;
  total: number;
  pageLimit: number;
  pageNumber: number;
  length: number;
  showingCount: { start: number; end: number };
};

const pageSizes = [
  {
    label: 'Show 10',
    value: 10,
  },
  {
    label: 'Show 25',
    value: 25,
  },
  {
    label: 'Show 50',
    value: 50,
  },
  {
    label: 'Show 100',
    value: 100,
  },
];

const Pagination: Component<PaginationProps> = (props: PaginationProps) => {
  const handlePageLimitChange = (value: string) => {
    props.gridApi!.setGridOption('paginationPageSize', Number(value));
  };

  const goToNextPage = () => {
    props.gridApi!.paginationGoToNextPage();
  };

  const goToPreviousPage = () => {
    props.gridApi!.paginationGoToPreviousPage();
  };

  const jumpFivePage = () => {
    props.gridApi!.paginationGoToPage(5);
  };

  const goBackFivePage = () => {
    props.gridApi!.paginationGoToPage(
      props.gridApi!.paginationGetCurrentPage() - 5,
    );
  };

  return (
    <Grid
      container
      justifyContent="space-between"
      class="bg-white p-2 flex-wrap"
    >
      <Grid class="flex items-center">
        <Typography variant="caption" component="p">
          Showing {props.showingCount.start} to {props.showingCount.end} of{' '}
          {props.length}
        </Typography>
      </Grid>
      <Grid class="flex" gap={2}>
        <Grid class="flex items-center" gap={0.5}>
          <ChevronDoubleLeftIcon
            onClick={goBackFivePage}
            class="text-gray-300 cursor-pointer"
          />
          <ChevronLeftIcon
            onClick={goToPreviousPage}
            class="text-gray-300 cursor-pointer"
          />
          <Typography
            variant="caption"
            component="p"
            sxProps={{
              fontWeight: 'bold',
              width: 'max-content',
              display: 'flex',
              gap: '5px',
            }}
          >
            <span class="text-gray-600">Page</span>
            {props.pageNumber} of {props.total}
          </Typography>
          <ChevronRightIcon
            onClick={goToNextPage}
            class="text-gray-300 cursor-pointer"
          />
          <ChevronDoubleRightIcon
            onClick={jumpFivePage}
            class="text-gray-300 cursor-pointer"
          />
        </Grid>
        <Grid container gap={1} alignItems="center">
          <Typography variant="caption" component="p">
            Go to Page :
          </Typography>
          <TextField
            dataTestId={'pageNumber-textInput'}
            type="number"
            id="pageNumberId"
            label=""
          />
        </Grid>
        <div class="inline-flex flex-col min-w-[100px]">
          <SelectInput
            label="pageLimit"
            value={String(props.pageLimit)}
            menuItems={pageSizes.map((pageSize) => ({
              label: pageSize.label,
              value: String(pageSize.value),
            }))}
            onChange={handlePageLimitChange}
            dataTestId="pagination-page-limit-select"
            size="sm"
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default Pagination;
